const CONST_SETTING_PASSWORD = {
  SETTING_PASSWORD: 'パスワード設定',
  GIVE_PASSWORD: 'パスワード再設定',
  NEW_PASSWORD: '新規パスワード',
  CONFIRM_NEW: '新規パスワード(確認)',
  SEND: '登　録',
  REGISTER: '設　定',
  EMPTY_PASSWORD: '新規パスワードは必須です',
  EMPTY_CONFIRM_PASSWORD: '新規パスワード(確認)は必須です',
  INCORRECT_PASSWORD: '新規パスワード(確認)は新規パスワードと同じ場合のみ有効です',
  SETTING_SUCCESS: 'パスワードが正常に設定されました',
  SETTING_FAILED: 'パスワードが設定できませんでした',
  WITHIN: '新規パスワードは半角の英数字8文字以上です',
  PLACEHOULDER_PWD: '半角の英数字8文字以上',
  CONFIRMED_LINK: 'メールの利用期限が切れました。',
  TIME_UP: 'このURLの有効期限が切れました。',
};

export default CONST_SETTING_PASSWORD;
